import { Component, Input, inject } from '@angular/core';
import {ToolsService} from '../../services/tools/tools.service';
import {LocalStorage} from 'ngx-webstorage';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {DemandeProlongation} from '../../../interface/api/DemandeProlongation';
import { DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-demande-prolongation-detail',
    templateUrl: './demande-prolongation-detail.component.html',
    styleUrls: ['./demande-prolongation-detail.component.scss'],
    imports: [MatIcon, DatePipe, TranslateModule]
})
export class DemandeProlongationDetailComponent {
    toolService = inject(ToolsService);
    translateService = inject(TranslateService);


    @Input('demandeProlongation') public demandeProlongation: DemandeProlongation;
    @Input('isAdmin') public isAdmin = false;

    @LocalStorage() public dateShort;

}
